import { CircularProgress, Flex } from '@chakra-ui/react';

/**
 * @deprecated
 * We must eventually delete all such abominations and replace with a single loader from design system
 */
const Spinner = ({ centered, ...props }: any) => {
  const progressCircle = (
    <CircularProgress
      isIndeterminate
      color="primary.500"
      trackColor="primary.100"
      {...props}
    />
  );
  return centered ? (
    <Flex align="center" justify="center" padding={5}>
      {progressCircle}
    </Flex>
  ) : (
    progressCircle
  );
};

export default Spinner;
